
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import Toasted from 'vue-toasted';
import { handleError } from '../../../../api';
import { WindowType } from '../../../../util';
import { Attachment, Board, Card, Media, Ticket } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    VueSimpleContextMenu,
  },
})
export default class Attachments extends Vue {
  @Prop()
  modalId: string | undefined;
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  board!: Board;
  @Prop({ required: true })
  flow!: Ticket;
  @Prop({ required: true })
  card!: Card;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: false })
  lockeddown!: boolean;

  attachmentContextMenuOptions = [{ id: 'delete', name: 'Delete' }];
  attachmentContextMenu!: VueSimpleContextMenu;
  media: Media[] | null = null;

  mounted(): void {
    this.attachmentContextMenu = this.$refs.attachmentContextMenu;
  }

  deleteAttachment(attachment: Attachment): void {
    if (this.readonly) {
      return;
    }

    const card = this.card;
    const index = (card.attachments ?? []).findIndex(e => e.id === attachment.id);
    if (index > -1) {
      const attach = card.attachments![index];

      //save to backend
      this.state.attachmentAPI.delete(attach.id, card.id)
          .then(_ => {
            this.$toasted.info(this.$t('txtDeleted').toString());
            card.attachments?.splice(index, 1);
            card.updatedOnForReadConfirmation = new Date();
          })
          .catch(e => handleError(this.$toasted, this.$i18n, e));
    }
  }

  //util
  modalClientOffset(): { x: number, y: number } {
    let anchor = (this.modalId && document.getElementById(this.modalId)?.getElementsByClassName('modal-body')[0]) || document.body;
    let rect = anchor.getBoundingClientRect();
    let pleft = parseInt(window.getComputedStyle(anchor)['padding-left']);
    let ptop = parseInt(window.getComputedStyle(anchor)['padding-top']);
    return {
      x: rect.x + pleft,
      y: rect.y + ptop,
    };
  }

  //event handler
  onAttachmentClicked(event: PointerEvent, attachment: Attachment) {
    if (this.readonly) {
      return;
    }

    let offset = this.modalClientOffset();
    this.attachmentContextMenu.showMenu({
      pageX: event.pageX - offset.x,
      pageY: event.pageY - offset.y,
    }, attachment);
  }

  onAttachmentContextMenuClicked(event: { item: Attachment, option: { id: string } }): void {
    if (this.readonly) {
      return;
    }

    if (event.option.id === 'delete') {
      this.deleteAttachment(event.item);
    }
  }
}

